import React from "react";

import { controller } from "../controller";
import Helcim from "./Helcim";

/**
 * Fetches the Helcim.js token, then renders the card form.
 *
 * `billing` is what the customer entered on the step before, so the card form
 * can inherit the name and address instead of asking for them again. It is
 * absent for a returning customer, whose details we already hold but have no
 * endpoint to read back — the card form shows those fields in that case.
 */
const HelcimForm = ({ billing, submitText, chargeNote }) => {
  const [helcimConfig, setHelcimConfig] = React.useState({});

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await controller.getHelcimToken();
        if (!cancelled && response && response.status < 250) setHelcimConfig(response);
      } catch (e) {
        console.error("Could not load the card form token", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Helcim
      helcimConfig={helcimConfig}
      billing={billing}
      submitText={submitText}
      chargeNote={chargeNote}
    />
  );
};

export default HelcimForm;
